import React from "react";
import Footer from "../components/Footer";
import Projects from "../components/Projects";
import { motion } from "framer-motion";
import { FaMobileAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../pages/Services.css";

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="services-container">
          {/* ✅ Web Development Section */}
          <div className="web-development-section">
            <h2>{t("services.web.title")}</h2>
            <p>{t("services.web.desc")}</p>
            <Projects type="website" />
          </div>

          {/* ✅ Mobile App & IT Consulting Section */}
          <div className="services-list">
            <motion.div className="service-box">
              <FaMobileAlt className="service-icon" />
              <h2>{t("services.mobile.title")}</h2>
              <p>{t("services.mobile.desc")}</p>
              <Projects type="mobile" />
            </motion.div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;